import { render, staticRenderFns } from "./ProgramDocuments.vue?vue&type=template&id=2f961064&scoped=true&"
import script from "./ProgramDocuments.vue?vue&type=script&lang=js&"
export * from "./ProgramDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDocuments.vue?vue&type=style&index=0&id=2f961064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f961064",
  null
  
)

export default component.exports